import { isEmpty } from 'lodash';

const notFound = (value: any[]): string | null => (isEmpty(value) ? 'Campo obrigatório.' : null);

export default notFound;
